class Database
{
  constructor ()
  {
    this.databaseName = 'donor_cache';
  }

  open ()
  {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('', 1);

      request.onerror = e => {
        reject(e);
        console.error('indexedDB error', e);
      }

      request.onsuccess = e => {
        resolve(e.target.result, e);
      }

      request.onupgradeneeded = e => {
        const db = e.target.result;
        db.createObjectStore(this.databaseName);
      }
    });
  }

  get (key)
  {
    return new Promise((resolve, reject) => {
      if (!indexedDB) {
        return resolve(null);
      }

      this.open().then(db => {
        const transaction = db.transaction([this.databaseName]);
        const objectStore = transaction.objectStore(this.databaseName);
        const request = objectStore.get(key);

        request.onerror = e => {
          console.log('indexedDB GET transaction error', e);
          reject(e);
        };

        request.onsuccess = e => {
          const json = request.result;

          if (typeof(json) !== 'undefined' && json !== null) {
            const now = (new Date()).getTime();

            // Check cache time is valid
            if (typeof(json.ttl) !== 'undefined') {
              if (now - json.ttl < 0) {
                return resolve(json.data);
              }

              // Expired
              this.forget(key);

              resolve(null);
            } else {
              return resolve(json.data);
            }
          } else {
            resolve(null);
          }
        };
      });
    });
  }

  put (key, obj, seconds)
  {
    return new Promise((resolve, reject) => {
      if (!indexedDB) {
        return resolve(null);
      }

      this.open().then(db => {
        const transaction = db.transaction([this.databaseName], 'readwrite');
        const objectStore = transaction.objectStore(this.databaseName);
        const data = {
          data: obj
        };

        // Time to live for cache
        if (typeof(seconds) !== 'undefined') {
          data.ttl = (new Date()).getTime() + seconds * 1000;
        }

        const request = objectStore.put(data, key);

        request.onerror = e => {
          console.error('indexedDB PUT transaction error', e);
          reject(e);
        };

        request.onsuccess = e => {
          resolve(request.result);
        };
      });
    });
  }

  forever (key, obj)
  {
    return this.put(key, obj);
  }

  forget (key)
  {
    return new Promise((resolve, reject) => {
      if (!indexedDB) {
        return resolve(null);
      }

      this.open().then(db => {
        const transaction = db.transaction([this.databaseName], 'readwrite');
        const objectStore = transaction.objectStore(this.databaseName);
        const request = objectStore.delete(key);

        request.onerror = e => {
          console.error('indexedDB DELETE transaction error', e);
          reject(e);
        };

        request.onsuccess = e => {
          resolve(request.result);
        };
      });
    });
  }

  flush ()
  {
    return new Promise((resolve, reject) => {
      if (!indexedDB) {
        return resolve(null);
      }

      this.open().then(db => {
        const transaction = db.transaction([this.databaseName], 'readwrite');
        const objectStore = transaction.objectStore(this.databaseName);
        const request = objectStore.getAllKeys();

        request.onerror = e => {
          console.error('indexedDB FLUSH transaction error', e);
          reject(e);
        };

        request.onsuccess = e => {
          const keys = request.result;

          if (keys.length === 0) {
            return resolve();
          }

          let flushed = 0;

          keys.forEach(key => {
            this.forget(key).then(() => {
              flushed++;

              if (flushed === keys.length) {
                resolve(request.result);
              }
            });
          });
        };
      });
    });
  }

  keys ()
  {
    return new Promise((resolve, reject) => {
      if (!indexedDB) {
        return resolve(null);
      }

      this.open().then(db => {
        const transaction = db.transaction([this.databaseName]);
        const objectStore = transaction.objectStore(this.databaseName);
        const request = objectStore.getAllKeys();

        request.onerror = e => {
          console.error('indexedDB FLUSH transaction error', e);
          reject(e);
        };

        request.onsuccess = e => {
          resolve(request.result);
        };
      });
    });
  }

  forgetExpired ()
  {
    try {
      this.keys().then(keys => {
        keys.forEach(key => {
          // Get will auto clear expired
          this.get(key);
        });
      });
    } catch (e) {
      //
    }
  }

  async size ()
  {
    if (!navigator.storage) {
      return 0;
    }

    const estimate = await navigator.storage.estimate();

    return this.toHumanSize(estimate.usage);
  }

  toHumanSize (size)
  {
    const i = size == 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));

    return +((size / Math.pow(1024, i)).toFixed(2)) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
  }
}